import { useEffect, useState } from 'react';
import styles from './thinking.module.scss';
import TypeIt from 'typeit';

const ThinkingSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const thinkingMessages = [
        "Digesting Responses",
        "Prepping Profile",
        "Sharpening Knives",
        "Preheating Oven",
        "Analyzing Tastes",
        "Matching Interests",
        "Comparing Passions",
        "Personalizing Results",
        "Plating Recommendations"
      ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % thinkingMessages.length);
        }, 1500);

        new TypeIt("#content", {
            speed: 25,
        })
        .type('Every brilliant cook started somewhere. With guidance from the world’s top chefs, you’ll discover simple yet impressive ways to transform your meals.')
        .break()
        .break()
        .type('Every brilliant cook started somewhere. With guidance from the world’s top chefs, you’ll discover simple yet impressive ways to transform your meals.')
        .break()
        .break()
        .go();

        return () => clearInterval(interval); // cleanup on unmount
    }, []);

    return(
        <div className={styles.ThinkingSection}>
            <h2 className={styles.Title}>Analyzing Interests.</h2>
            <div className={styles.Animation}>
                <div className={styles.Image}>
                    <img src="https://static.yeschef.me/animated-thinking.gif" alt="Thinking animation" />
                </div>
                <div className={styles.AnimatedText}>{thinkingMessages[currentIndex]}</div>
            </div>

            <div className={styles.ContentWrapper}>
                <h2 className={styles.SectionTitle}>Plating your results</h2>
                <div className={styles.SectionSubtitle}>Ready to unlock a whole new world of cooking confidence?</div>
                <div id="content"></div>
            </div>
        </div>
    );
}

export default ThinkingSection;